import script from "./LoveLetter.vue?vue&type=script&setup=true&lang=js"
export * from "./LoveLetter.vue?vue&type=script&setup=true&lang=js"

import "./LoveLetter.vue?vue&type=style&index=0&id=71894791&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71894791"]])

export default __exports__